/**
 * Outcomes is reached through two routes: `/outcomes-intro`, which the navigation
 * links to, and `/outcomes`, the indicator page the intro hands over to. Angular's
 * routerLinkActive only matches the link's own URL, so it drops the highlight the
 * moment the user moves on to the indicator page. Every navigation surface uses
 * this helper instead so the section stays lit across both.
 */
export const OUTCOMES_ROUTES: ReadonlyArray<string> = ['/outcomes', '/outcomes-intro'];

/** Strips the query string and any fragment before matching. */
export function isOutcomesRoute(url: string): boolean {
  const path = (url || '').split('?')[0].split('#')[0];
  return OUTCOMES_ROUTES.includes(path);
}
